import './novelMenu.css';
import React, { useState, useEffect, useRef } from 'react';
import plot from'../../services/plot'
import parse from 'html-react-parser'
import chapter1 from'../../services/chapter1'
import mainImg from'../../images/menuPic.png'
import {IsLSWork} from '../app/app'


function NovelMenu({goPlay, step, setStep, state, goToGallery, goToCredits, achievementsSave, plot, loadingGif, defaultMenu, hzAdjuster}) {
  const [isLS, setIsLS] = useState(IsLSWork());
  const wrap = useRef(null);
  const mainImgRef = useRef(null);
  const popUp = useRef(null);
  const progressRef = useRef(null);
  //
  const achievementsProgress = useRef(0);
  const exit = useRef(false);
  const achievementsMenu = useRef(new Array(...achievementsSave.current));
  const startChapter = useRef(false);
  //
  const [charName, setCharName] = useState();
  const [achievementsOn, setAchievementsOn] = useState(false);
  const [newGame, setNewGame] = useState(false);
  const [achievementsComplete, setAchievementsComplete] = useState(0);
  const [percent, setPercent] = useState(0);
  useEffect(() => {

  });

  var sheet = window.document.styleSheets[0];
  useEffect(() => {

    async function start(){
      setAchievementsComplete(0);
      let achievementsCompleteNum = 0;
      for(let i=0;i<achievementsSave.current.length;i++){
        if(achievementsSave.current[i][2] == 1){
          setAchievementsComplete(previous => previous + 1);
          achievementsCompleteNum++;
          achievementsProgress.current++;
        }
      }
      for(let i = 0;i<achievementsMenu.current.length;i++){
        if(achievementsMenu.current[i][4]){
          achievementsMenu.current.splice(i, 1);
          achievementsMenu.current.splice(achievementsSave.current[i][4], 0, new Array(...achievementsSave.current[i]));
          achievementsMenu.current[achievementsSave.current[i][4]][4] = false;
        }
      }
    await percentComplete(achievementsCompleteNum);
    sheet.insertRule('.dropdown input:checked ~ .dropdown__face{margin-bottom:'+(document.getElementsByClassName("dropdown__items")[0].clientHeight+20)+'px; }', sheet.cssRules.length);
    sheet.insertRule('.dropdown2 input:checked ~ .dropdown__face2{margin-bottom:'+(document.getElementsByClassName("dropdown__items2")[0].clientHeight+35)+'px; }', sheet.cssRules.length);
    sheet.insertRule('.dropdown__items2 li{display:none;}', sheet.cssRules.length);
    await loadImg();
    await changeSetting(wrap,"current.style.opacity", 0, "", 0.02);
    changeSetting(wrap,"current.style.zIndex", 0, "", 10);
    setTimeout(progressText, 2500);
  }
  start();
},[]);
//
function loadImg(){
  return new Promise(async (resolve, reject) => {
let image = new Image();
image.src = mainImg;
image.onload = () => {
window[mainImg] = image;
mainImgRef.current.style.background = "url("+mainImg+") fixed";
mainImgRef.current.style.backgroundSize ="auto 40%";
mainImgRef.current.style.backgroundPosition ="top right";
resolve();
}
});
}

let k=0;
async function progressText(){
  if(exit.current){
    return;
  }
  k++;
  if(k % 2 == 1){
    await changeSetting(progressRef,"current.style.opacity", 0, "", 0.02);
    if(exit.current){
      return;
    }
    progressRef.current.innerHTML = "achievements progress";
    if(achievementsProgress.current == achievementsSave.current.length){
      if(exit.current){
        return;
      }
      progressRef.current.innerHTML = "Ms. Ryder is proud of you💋";
    }
    await changeSetting(progressRef,"current.style.opacity", 1, "", 0.02);
  }else{
    await changeSetting(progressRef,"current.style.opacity", 0, "", 0.02);
	if(exit.current){
      return;
    }
    progressRef.current.innerHTML = achievementsProgress.current + " / " + achievementsSave.current.length;
    await changeSetting(progressRef,"current.style.opacity", 1, "", 0.02);
  }
  setTimeout(progressText, 2500);
}

function percentComplete(achievementsCompleteNum){
let displayedPercent = Math.round(achievementsCompleteNum/achievementsSave.current.length*100);
if(plot[plot.length-2]["script"]){
let plotI = plot[plot.length-2]["script"].length - 2;
if(state.current && state.current.length == plot.length-1 && state.current[state.current.length-1]["numI"] == plotI && plot[plot.length-2]["script"][plot[plot.length-2]["script"].length-2]["phrases"] && state.current[state.current.length-1]["numJ"] == plot[plot.length-2]["script"][plot[plot.length-2]["script"].length-2]["phrases"].length-1){
  setNewGame(true);
}else if(state.current && state.current.length == plot.length-1 && state.current[state.current.length-1]["numI"] == plotI && plot[plot.length-2]["script"][plot[plot.length-2]["script"].length-2]["phrases"] == undefined){
  setNewGame(true);
}
}else if(plot[plot.length-2]["chat"] || plot[plot.length-2]["groupChat"]){
if(state.current && state.current.length == plot.length-1 && state.current[state.current.length-1]["completed"]){
    setNewGame(true);
  }
}
if(defaultMenu){
  setNewGame(true);
}
let styleSheet = document.createElement('style');
styleSheet.type = 'text/css';
document.head.appendChild(styleSheet);
let animationCss = `@keyframes progressAnimation {
  0%   { width: 0%; background-color: #F9BCCA;}
  100% { width: `+displayedPercent+`%; background-color: #9b47ef; }
}`;
styleSheet.sheet.insertRule(animationCss,
styleSheet.length
);

setPercent(displayedPercent);
}

async function goPlayFromMenu(){
  changeSetting(wrap,"current.style.zIndex", 10, "", 10);
  await changeSetting(wrap,"current.style.opacity", 1, "", 0.02);
  for(let k = 0; k<sheet.rules.length;k++){
    if(sheet.rules[k].cssText == ".dropdown__items2 li { display: none; }"){
      sheet.removeRule(k);
    }
  }
  exit.current = true;
  goPlay();
}

async function goToGalleryFromMenu(){
  changeSetting(wrap,"current.style.zIndex", 10, "", 10);
  await changeSetting(wrap,"current.style.opacity", 1, "", 0.02);
  for(let k = 0; k<sheet.rules.length;k++){
    if(sheet.rules[k].cssText == ".dropdown__items2 li { display: none; }"){
      sheet.removeRule(k);
    }
  }
  exit.current = true;
  goToGallery();
}

async function goToCreditsFromMenu(){
  changeSetting(wrap,"current.style.zIndex", 10, "", 10);
  await changeSetting(wrap,"current.style.opacity", 1, "", 0.02);
  for(let k = 0; k<sheet.rules.length;k++){
    if(sheet.rules[k].cssText == ".dropdown__items2 li { display: none; }"){
      sheet.removeRule(k);
    }
  }
  exit.current = true;
  goToCredits();
}

async function areYouSure(e){
startChapter.current = e.currentTarget.value;
document.body.classList.add("stop-scrolling");
changeSetting(popUp,"current.style.zIndex", 15, "", 15);
changeSetting(wrap,"current.style.zIndex", 10, "", 10);
changeSetting(wrap,"current.style.opacity", 0.3, "", 0.03);
await changeSetting(popUp.current.getElementsByClassName('popUp')[0],"style.transform", 1, "scale", 0.03);
}

async function areYouSureNoBg(e){
  if(e.target !== e.currentTarget) return;
document.body.classList.remove("stop-scrolling");
changeSetting(wrap,"current.style.opacity", 0, "", 0.025);
await changeSetting(popUp.current.getElementsByClassName('popUp')[0],"style.transform", 0, "scale", 0.05);
changeSetting(popUp,"current.style.zIndex", 0, "", 15);
changeSetting(wrap,"current.style.zIndex", 0, "", 10);
}

async function areYouSureNo(){
document.body.classList.remove("stop-scrolling");
changeSetting(wrap,"current.style.opacity", 0, "", 0.025);
await changeSetting(popUp.current.getElementsByClassName('popUp')[0],"style.transform", 0, "scale", 0.05);
changeSetting(popUp,"current.style.zIndex", 0, "", 15);
changeSetting(wrap,"current.style.zIndex", 0, "", 10);
}
async function areYouSureYes(e){
  if(startChapter.current == false){
    startChapter.current = e.currentTarget.value;
  }
  if(startChapter.current == undefined){
    startChapter.current = 0;
  }
  if(startChapter.current == 0){
    setStep(0);
    state.current = [{numI:0,numJ:0,savedAnswers:"[]"}];
    if(isLS){
    localStorage.setItem('stepSC1', 0);
    localStorage.setItem('stateSC1', JSON.stringify(state.current));
  }
  }else if(startChapter.current == 1){
    setStep(chapter1.length);
      if(isLS){
    localStorage.setItem('stepSC1', chapter1.length);
  }
    state.current =[];
    for(let k=0;k<chapter1.length;k++){
    state.current.splice(k, 1, null)
      if(isLS){
    localStorage.setItem('stateSC1', JSON.stringify(state.current));
  }
    }
  }
  document.body.classList.remove("stop-scrolling");
  changeSetting(wrap,"current.style.zIndex", 20, "", 10);
  await changeSetting(wrap,"current.style.opacity", 1, "", 0.02);
  for(let k = 0; k<sheet.rules.length;k++){
    if(sheet.rules[k].cssText == ".dropdown__items2 li { display: none; }"){
      sheet.removeRule(k);
    }
  }
  exit.current = true;
  goPlay();
}



function changeSetting(obj, setting, changeTo, um, speed, char){
  if(exit.current){
    return;
  }
  speed = speed*2*hzAdjuster;
  return new Promise((resolve, reject) => {
    const props = setting
        .split(/[./[\]]/g)
        .filter(p => p);
    const prop = props.pop();
    const parent = props.reduce((result, key) => result[key], obj);
    //
    var i;
    if(setting == "current.style.transform" || setting == "style.transform"){
      i = Math.round(parseFloat(parent[prop].split("(")[1].split(")")[0]));
    }else{
      i = Math.round(parseFloat(parent[prop]));
    }
    let slowDownTrigger = 0;
  //  if(char){//delete
  //slowDownTrigger = Math.round(parseFloat(Math.abs((char.initialPointX[0]-char.destinationPointX)/char.speed)*0.8));//moment of slower of char
  //}
  //  let slowDownCounter=0;
    let slower = 8;
    change();
  function change(){
    //slowDownCounter++;
  //  if(slowDownCounter > slowDownTrigger && char != undefined){ //delete
  //    slower+=3; //slower of char
  //  }
  //  console.log(slower);
    if(i>changeTo){
      i-=speed;
      if(i<changeTo){
        i = changeTo;
        if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
          parent[prop] = "scale("+i+")";
        }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
          parent[prop] = "rotateY("+i+"deg)";
        }else{
          parent[prop] = i+um;
        }
        resolve();
        return;
      }
  }else if(i<changeTo){
    i+=speed;
    if(i>changeTo){
      i = changeTo;
      if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
        parent[prop] = "scale("+i+")";
      }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
        parent[prop] = "rotateY("+i+"deg)";
      }else{
        parent[prop] = i+um;
      }
      resolve();
      return;
    }
  }else{
    if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
      parent[prop] = "scale("+i+")";
    }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
      parent[prop] = "rotateY("+i+"deg)";
    }else{
      parent[prop] = i+um;
    }
    resolve();
    return;
  }
  if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
    parent[prop] = "scale("+i+")";
  }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
    parent[prop] = "rotateY("+i+"deg)";
  }else{
    parent[prop] = i+um;
  }
requestAnimationFrame(change);
return;
}
});
}
  return (
    <>
    <div className='clickWrapVN' ref={wrap} id="wrap" style={{opacity:"1",zIndex:"10"}}></div>
    <div className="centerize" ref={popUp} onClick={areYouSureNoBg} style={{zIndex:0}}> <div className="popUp" style={{transform:"scale(0)"}}><h2>Are you sure you want to start new game? All previous progress will be lost(Except achievements)</h2>
    <div className="buttons">
    <button className="button2" onClick={areYouSureYes}><span>Yes</span></button>
    <button className="button2" onClick={areYouSureNo}><span>No</span></button>
    </div>
    </div>
    </div>
<div className="novelPic" ref={mainImgRef}>
</div>
<div className="menuWrapUnder"></div>
<div className="menuWrap">
<div className="novelMenu">
<div className="container">
  <div className="progress2 progress-moved">
    <div className="progress-bar2" style={{width: percent+"%"}}>
    </div>
  <div className="progress2_percent" style={{opacity:"1"}} ref={progressRef}>{achievementsComplete} / {achievementsSave.current.length}</div>
  </div>
</div>
<button className="playButton" onClick={newGame ? areYouSure : goPlayFromMenu} style={newGame ? {right:"5vw", paddingLeft:"4vw", paddingRight:"4vw", fontSize:"21px"} : !!state.current.length ? {right:"5vw", paddingLeft:"4vw", paddingRight:"4vw", fontSize:"23px"} : {right:"10vw",paddingLeft:"7vw", paddingRight:"7vw",fontSize:"25px"}}><span>{newGame ? "New Game" : !!state.current.length ? "Continue" : "Play"}</span></button>
<h1>SexEd Course</h1>
<p>Welcome to classes you've been wishing for! Dear students, please, prepare a couple of tissues beforehand.</p>
<div className="dropdownBoxes">
{!!state.current.length && <div className="dropdown0" onClick={areYouSure}>
  <label className="dropdown__face0" htmlFor="dropdown0">
    <div className="dropdown__text">🔄 NEW GAME</div>
  </label>
</div>}

<div className="dropdown4" style={{ filter:"grayscale(100%)"}} >
  <label className="dropdown__face4" htmlFor="dropdown4">
    <div className="dropdown__text">💾 LOAD<small>|<small>in development</small>|</small></div>
  </label>
</div>

<div className="dropdown">
  <input type="checkbox" id="dropdown"/>

  <label className="dropdown__face" htmlFor="dropdown">
    <div className="dropdown__text">🍌 CHAPTERS</div>

    <div className="dropdown__arrow"></div>
  </label>

  <ul className="dropdown__items">
    <li onClick={!!state.current.length ? areYouSure : goPlayFromMenu} value="0"><h3 value="0">VULVA</h3></li>
    <a href="https://www.patreon.com/posts/chapter-2-for-b-126936362" target="_blank"><li value="1"><div><h3 value="1">VULVA PRACTICING</h3><h6 style={{color:"#f5ac40"}}>AVAILABLE ON PATREON</h6></div></li></a>
    <li style={{color: "#b3b3b3", cursor:"auto", border: "1px solid #b3b3b3" }}><div><h3>HOMEWORK</h3><h6>COMING SOON</h6></div></li>
  </ul>
</div>

<div className="dropdown2">
  <input type="checkbox" id="dropdown2"/>

  <label className="dropdown__face2" htmlFor="dropdown2">
    <div className="dropdown__text">🏆 ACHIEVEMENTS</div>

    <div className="dropdown__arrow2"></div>
  </label>

  <ul className="dropdown__items2">
  {achievementsMenu.current.map((item,index)=>{
    return(
      <li style={item[2] ? {color: "#fff", filter:"grayscale(0%)"} : {color: "grey", filter:"grayscale(100%)"}} key={index}><span>{parse(item[0]+item[1])}</span><span>✅</span></li>
    );
    })}
  </ul>
</div>


<div className="dropdown3" onClick={goToGalleryFromMenu}>
  <label className="dropdown__face3" htmlFor="dropdown3">
    <div className="dropdown__text">🎴 GALLERY<sup style={{color:"#4dc740"}}><small><small>NEW!</small></small></sup></div>
  </label>
</div>

<div className="dropdown3" onClick={goToCreditsFromMenu}>
  <label className="dropdown__face3" htmlFor="dropdown3">
    <div className="dropdown__text">📜 CREDITS</div>
  </label>
</div>
<a href="https://www.patreon.com/almondraf" target="_blank">
<div className="dropdown3">
  <label className="dropdown__face3" htmlFor="dropdown3">
    <div className="dropdown__text">💖 SUPPORT US</div>
  </label>
</div>
</a>
</div>
</div>
</div>
</>
  );
}

export default NovelMenu;
